<div class="flex flex-col">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-general-title color-blue">
      {{ this.data.Titule }}
    </p>

    @if (this.data.buttonClose) {
      <button
        (click)="closeModal()"
        class="flex! justify-center! items-center!"
        color="primary"
        mat-icon-button
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  @if (data.text) {
    <div
      class="py-3 px-5 flex flex-col overflow-auto box-scroll text-general text-var(--color-text-primary)"
    >
      {{ this.data.text }}
    </div>
  }

  <div class="px-4 mx-4">
    <app-input-general-text
      [formControlGeneral]="formControlGeneral"
      [label]="data.label ?? ''"
      [placeholder]="data.placeholder"
    ></app-input-general-text>
  </div>

  <div class="flex justify-center p-2 w-full gap-4">
    @if (this.data.isCommentEmpty) {
      <button
        matButton="filled"
        class="w-45 h-13! rounded-xl text-white! button-general"
        (click)="emptyComment()"
      >
        {{ this.data.emptyCommentButtonText }}
      </button>
    }
    <button
      [disabled]="!formControlGeneral.valid && this.data.isRequired"
      matButton="filled"
      class="w-45 h-13! rounded-xl text-white! bg-(--comp-button-bg-primary)!"
      (click)="emitValue()"
    >
      {{ this.data.button }}
    </button>
  </div>
</div>
